module.exports = __webpack_public_path__ + "media/images/shiga-1260396748f8e10ab2c6dfe127aa5dfc.jpg";